import { FormEvent, useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import './Login.css';

export default function Login() {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState('');

  // Se já estiver autenticado, redireciona para o dashboard
  if (isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setProcessing(true);

    try {
      await login(username, password);
      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Erro ao fazer login. Verifique suas credenciais.');
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <div className="login-icon">
            <img src="/logo_infor.png" alt="Infor" width={44} height={44} />
          </div>
          <span className="login-eyebrow">Infor Sistemas</span>
          <h1 className="login-title">SNGPC Web Infor</h1>
          <p className="login-subtitle">Sistema Nacional de Gerenciamento de Produtos Controlados</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="login-error">
              <p>{error}</p>
            </div>
          )}

          <div className="login-field">
            <label htmlFor="email" className="login-label">
              Usuário
            </label>
            <input
              id="email"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="login-input"
              placeholder="Digite seu usuário"
              required
              autoFocus
            />
          </div>

          <div className="login-field">
            <label htmlFor="password" className="login-label">
              Senha
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="login-input"
              placeholder="Digite sua senha"
              required
            />
          </div>

          <button
            type="submit"
            disabled={processing}
            className="login-button"
          >
            {processing ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

      </div>
    </div>
  );
}
